import posthog from "posthog-js"

const apiKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined

export function initPostHog() {
  if (!apiKey) return

  posthog.init(apiKey, {
    api_host: "/ph",
    ui_host: "https://eu.posthog.com",
    capture_pageview: false, // we track manually on Inertia navigations
    capture_pageleave: true,
    persistence: "localStorage+cookie",
  })
}

export function identifyUser(user: { id: string; email: string }) {
  if (!apiKey) return

  posthog.identify(user.id, { email: user.email })
}

export function resetUser() {
  if (!apiKey) return

  posthog.reset()
}

export function captureEvent(
  event: string,
  properties?: Record<string, unknown>,
) {
  if (!apiKey) return

  posthog.capture(event, properties)
}

export function capturePageview() {
  if (!apiKey) return

  posthog.capture("$pageview")
}

export { posthog }
